export default __webpack_public_path__ + "static/media/ascentive-assets.217b7843.svg";